import * as api from '../../api';

export const publishActions = api.fetchActions('publish-intake-form', 'publish-form');
export const retractActions = api.fetchActions('publish-intake-form', 'retract-form');

export const actionTypes = {
  ...publishActions.actionTypes,
  ...retractActions.actionTypes,
};

export const publishForm = (id) => api.postThunk(`/intake/${id}/publish`, { isPublished: true}, publishActions, {id});
export const retractForm = (id) => api.postThunk(`/intake/${id}/publish`, { isPublished: false}, publishActions, {id});
